import { Component, EventEmitter, Injector, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, NgForm } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { EvsAddressService } from '../../../../../common/services/EvsAddress.service';
import { CustomerService } from '../customer.service';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/Subscription';

declare var $: any;

@Component({
    selector: 'app-edit',
    templateUrl: './edit.component.html',
    styleUrls: ['./edit.component.css'],
    providers: [EvsAddressService]
})
export class EditComponent implements OnInit, OnDestroy {
    @Input('itemId') itemId: any;
    @Output('backUpdate') backUpdate = new EventEmitter();
    public customer: any = {};
    public message: { class: string, content: string } = null;
    public error: string = '';
    public cities: Array<any> = [];
    public districts: Array<any> = [];
    public componentData = null;
    public routerChange: any;
    public id: number = 0;
    private langSub: Subscription;

    constructor(private injector: Injector,
        private _location: Location,
        private service: CustomerService,
        public addressService: EvsAddressService,
        private activatedRoute: ActivatedRoute,
        private _fb: FormBuilder,
        private toastr: ToastrService,
        private translate: TranslateService) {
    }

    ngOnInit() {
        var that = this;
        this.initSelect2();
        this.langSub = this.translate.onLangChange.subscribe(() => {
            this.initSelect2();
        });
        $('#_province').on("select2:select", function (e) {
            $(".select2-selection__rendered").removeAttr('title');
            var id = e.target.value;
            that.loadDistrictData(id);
        });
        $('#_district').on("select2:select", function (e) {
            $(".select2-selection__rendered").removeAttr('title');
        });
        this.routerChange = this.activatedRoute.params.subscribe((params: Params) => {
            this.id = params['id'];
            this.getDetail(this.itemId);
        });
    }

    initSelect2() {
        $('#_province').select2({ placeholder: this.translate.instant('TINH_THANH'), allowClear: false });
        $('#_district').select2({ placeholder: this.translate.instant('QUAN_HUYEN_LABEL'), allowClear: false });
    }

    ngOnDestroy() {
        if (this.langSub) {
            this.langSub.unsubscribe();
        }
    }

    getDetail(id) {
        this.service.getDetailById(id).toPromise().then(res => {
            if (res) {
                if (!res.error) {
                    this.customer = res.data;
                    this.getCity();
                } else {
                    this.message = { class: "alert dark alert-danger", content: 'Error: ' + res.message };
                }
            }
        },
            error => {
                this.message = { class: "alert dark alert-danger", content: 'Error: ' + error };
            });
    }

    backToComponent() {
        this.backUpdate.emit({
            isBack: true
        })
        //this._location.back();
    }

    getCity() {
        this.addressService.getCities().subscribe(res => {
            let citiesList = [];
            res.data.cities.forEach((c: any) => {
                citiesList.push({
                    value: c.city_name,
                    label: c.city_name,
                    id: c.id,
                });
                if (c.city_name == this.customer.city) {
                    this.loadDistrictData(c.id);
                }
            });
            this.cities = citiesList;
        });
    }

    loadDistrictData(id: number) {
        this.addressService.getDistrict({ city_id: id }).toPromise().then(res => {
            let districts = [];
            res.data.districts.forEach((c: any) => {
                districts.push({
                    value: c.district_name,
                    label: c.district_name,
                    id: c.id,
                });
            });
            this.districts = districts;
        })
    }

    onSubmit(form: NgForm) {
        this.message = null;
        let objectData = {};

        let province = $('#_province option:selected').val();
        let district = $('#_district option:selected').val();

        if (this.customer.name.trim().length === 0)
            this.message = { class: "alert alert-danger", content: "Tên không được bỏ trống !" };
        else if (this.customer.phone.trim().length === 0)
            this.message = { class: "alert alert-danger", content: "Điện thoại không được bỏ trống !" };
        else if (!province)
            this.message = { class: "alert alert-danger", content: "Bạn chưa chọn Tỉnh/TP !" };
        else if (!district)
            this.message = { class: "alert alert-danger", content: "Bạn chưa chọn Quận/Huyện !" };
        else {
            this.processSave();
            this.customer.province = $('#_province option:selected').text();
            this.customer.district = $('#_district option:selected').text();
            objectData = {
                "name": this.customer.name,
                "phone": this.customer.phone,
                "email": this.customer.email,
                "city": this.customer.province.trim(),
                "district": this.customer.district.trim(),
                "address": this.customer.address
            };
            //console.log('update: ', objectData);
            this.service.updateById(this.itemId, objectData).subscribe(res => {
                if (res) {
                    let error = res.error;
                    if (error) {
                        // this.message = {
                        //     class: "alert dark alert-danger",
                        //     content: res.status + ' : ' + res.message
                        // };
                        this.toastr.success(res.status + ' : ' + res.message, '', {
                            timeOut: 4000,
                            positionClass: 'toast-bottom-right'
                        });
                    } else {
                        // this.message = {
                        //     class: "alert dark alert-success",
                        //     content: "Cập nhật thành công !"
                        // };

                        this.toastr.success('Cập nhật thông tin khách hàng thành công', '', {
                            timeOut: 4000,
                            positionClass: 'toast-bottom-right'
                        });
                        this.backUpdate.emit({
                            isBack: false
                        })
                        this.getDetail(this.itemId);
                    }
                    // form.reset();
                }
            }, error => {
                this.message = { class: "alert dark alert-danger", content: error.message };
            });
        }

        this.scrollToTop();
    }

    processSave() {
        this.message = {
            class: "alert dark alert-info",
            content: "Đang thực thi..."
        };
    }

    scrollToTop() {
        $("html, body").animate({ scrollTop: 0 }, "slow");
    }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/customer/edit/edit.component.ts